import { dealerRoles } from 'constants/roles';

/**
 * Check if its a dealer user
 * @param {object} user
 * @return {boolean}
 */
export function isDealerUser(user) {
  if (user && user.roles) {
    for (let role of user.roles) {
      if (dealerRoles.includes(role.toLowerCase())) {
        return true;
      }
    }
  }

  return false;
}